export const colors = {
    darkGreen: "#0f3c3c",
    green: "#135050",
    lightGreen: "#05c799",
    purple: "#e1bbff",
    darkPurple: "#b68cd6",
    orange: "#ffa12e",
    offWhite: "#f3f1ed",
    red: "#e55d5d",
    shadow: "rgba(107, 107, 107, 0.571)",
    eggShell: "#e7e7e5",
    darkGray: "rgb(97, 97, 97)"
};
